// ---------------------------------------------------------- Mobile & Tablet Check //
const mobileAndTabletCheck = function() {
  let check = false;

  (function(a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| ) | webc | whit | wi(g | nc | nw) | wmlb | wonu | x700 | yas\- | your | zeto | zte\-/i.test(a.substr(0, 4))) {
      check = true;
    }
  }(navigator.userAgent || navigator.vendor || window.opera));

  if (check) {
    $('body').addClass('active');
  }

  return check;
};

mobileAndTabletCheck();

// ---------------------------------------------------------- Mobile Nav //
$('body').on('click', '#nav-mobile-list li', function() {
  const navItem = $(this);
  const subnav = $(this).find('ul');
  const link = $(this).find('a');
  const subnavItem = $(this).hasClass('nav-item');

  if (subnavItem) {
    $('#nav-mobile-list').slideToggle('fast');
    document.location.href = link.attr('href');
  }
  else if (subnav.length) {
    navItem.toggleClass('active');
    subnav.slideToggle('fast');
  }
  else if (link.length) {
    $('#nav-mobile-list').slideToggle('fast');
    document.location.href = link.attr('href');
  }
});

$('body').on('click', '#nav-mobile-button', () => {
  $('#nav-mobile-list').slideToggle('fast');
});

// ---------------------------------------------------------- Pause Videos When Loading //
$(window).on('beforeunload', () => {
  $('video').each(function() {
    $(this).get(0).pause();
  });
});

// ---------------------------------------------------------- Page Down Scroll/Auto //
const pageDownScroll = function(behavior, topPosition) {
  window.scroll({
    top: topPosition,
    left: 0,
    behavior,
  });
};

if (subPage && !subSubPage) {
  pageDownScroll('smooth', window.innerHeight);
}

// ---------------------------------------------------------- Page Down Button - Top Section //
$('body').on('click', '.page-down', () => {
  pageDownScroll('smooth', window.innerHeight);
});

// ---------------------------------------------------------- Which Transition Events Detection //
const whichTransitionEvent = function() {
  const el = document.createElement('transition');
  const transEndEventNames = {
    MozTransition: 'transitionend',
    OTransition: 'oTransitionEnd',
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
  };

  Object.entries(transEndEventNames).forEach(([key, value]) => {
    if (el.style[key] !== 'undefined') {
      return transEndEventNames[key];
    }

    return true;
  });

  return false;
};

const transEndEventName = whichTransitionEvent();

// ---------------------------------------------------------- Get Element Position on Page //
function getPosition(elm) {
  let xPos = 0;
  let yPos = 0;

  xPos += (elm.offsetLeft - elm.scrollLeft + elm.clientLeft);
  yPos += (elm.offsetTop - elm.scrollTop + elm.clientTop);

  return {
    x: xPos,
    y: yPos,
  };
}

// ---------------------------------------------------------- Add ScrollMagic Controller //
const scrollMagicController = new ScrollMagic.Controller();
const viewportHeight = $(window).height();

// ----------------------------- BUILD SCREEN MAGIC SCENES //
function buildScenes(scene) {
  const offset = scene.offset ? scene.offset : viewportHeight / 3;
  const triggerHook = scene.triggerHook ? scene.triggerHook : 'onEnter';
  const addClass = scene.addClass ? scene.addClass : 'active';
  const onEvent = scene.on ? scene.on : 'enter';
  const delay = scene.delay ? scene.delay : 0;

  for (let i = 0; i < scene.elms.length; i += 1) {
    new ScrollMagic.Scene({
      offset,
      reverse: false,
      triggerElement: scene.elms[i],
      triggerHook,
    })
      .on(onEvent, function() {
        const thisElm = this;

        setTimeout(() => {
          $(thisElm.triggerElement()).addClass(addClass);
        }, delay);
      })
      .addTo(scrollMagicController);
  }
}

// ----------------------------- Logo & Navigation Animation Cookies //
let logoAnimationDone = false;
let topSectionDelay = 1500;

// Write Cookie //
function writeCookie(name, value, hours) {
  let expires = '';

  if (hours) {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    expires = `; expires=${date.toGMTString()}`;
  }

  document.cookie = `${name}=${value}${expires}; path=/ ;secure`;
}

// Read Cookie //
if (document.cookie.split(';').filter(item => item.indexOf('causalLac=') >= 0).length) {
  logoAnimationDone = true;
  topSectionDelay = 0;
}

if (!logoAnimationDone) {
  $('#navbar-brand').addClass('animate');
  writeCookie('causalLac', true, 24);
}
else {
  $('#navbar-brand img').css('opacity', 1);
}

// ---------------------------------------------------------- Animations //
if (!logoAnimationDone) {
  const logoScene = {
    elms: [
      '#navbar-brand.animate',
    ],
  };

  buildScenes(logoScene);
}

// Top Section Left //
const topSectionScene = {
  elms: [
    '#top-menu',
    '.top-section-left',
    '.top-section-right',
  ],
  delay: topSectionDelay,
};

buildScenes(topSectionScene);

// ---------------------------------------------------------- Ticker //
const tickerCounter = function(tickerElm) {
  const ticker = document.getElementsByClassName(tickerElm);
  const startValue = $(`.${tickerElm}`).data('start');
  const endValue = $(`.${tickerElm}`).data('end');
  const duration = $(`.${tickerElm}`).data('duration');
  let specialArray = false;

  if (startValue < 0) {
    specialArray = $(`.${tickerElm}`).data('array');
    specialArray = specialArray.split(',');
  }

  // If character counts //
  if (specialArray) {
    $({ countChar: 0, countChar2: 0, countChar3: 0, countChar4: 0 })
      .animate({ countChar: specialArray.length - 1 }, {
        duration: duration / 4,
        easing: 'linear',
        queue: true,
        step() {
          ticker[0].innerHTML = specialArray[Math.ceil(this.countChar)];
        },
      })
      .animate({ countChar2: specialArray.length - 1 }, {
        duration: duration / 4,
        easing: 'linear',
        step() {
          ticker[0].innerHTML = specialArray[Math.ceil(this.countChar2)];
        },
        queue: true,
      })
      .animate({ countChar3: specialArray.length - 1 }, {
        duration: duration / 4,
        easing: 'linear',
        step() {
          ticker[0].innerHTML = specialArray[Math.ceil(this.countChar3)];
        },
        queue: true,
      })
      .animate({ countChar4: endValue }, {
        duration: duration / 4,
        easing: 'linear',
        step() {
          ticker[0].innerHTML = specialArray[Math.ceil(this.countChar4)];
        },
        queue: true,
      });
  }
  // If number counts //
  else if (endValue === 0) {
    $({ countNum: 0, countNum2: 0, countNum3: 0 })
      .animate({ countNum: 9 }, {
        duration: duration / 2,
        easing: 'linear',
        step() {
          ticker[0].innerHTML = Math.ceil(this.countNum);
        },
        queue: true,
      })
      .animate({ countNum2: 9 }, {
        duration: duration / 2,
        easing: 'linear',
        step() {
          ticker[0].innerHTML = Math.ceil(this.countNum2);
        },
        queue: true,
      })
      .animate({ countNum3: endValue }, {
        duration: duration / 3,
        easing: 'linear',
        step() {
          ticker[0].innerHTML = Math.ceil(this.countNum3);
        },
        queue: true,
      });
  }
  else {
    $({ countNum: 0, countNum2: 0 })
      .animate({ countNum: 9 }, {
        duration: duration / 2,
        easing: 'linear',
        step() {
          ticker[0].innerHTML = Math.ceil(this.countNum);
        },
        queue: true,
      })
      .animate({ countNum2: endValue }, {
        duration: duration / 2,
        easing: 'linear',
        step() {
          ticker[0].innerHTML = Math.ceil(this.countNum2);
        },
        queue: true,
      });
  }
};

if (
  document.getElementsByClassName('home-page').length >= 1 ||
  document.getElementsByClassName('products-page').length >= 1 ||
  document.getElementsByClassName('our-work-page').length >= 1 ||
  document.getElementsByClassName('about-page').length >= 1 ||
  document.getElementsByClassName('join-us-page').length >= 1
) {
  if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))) {
    $('.tag').css({
      top: 0,
      opacity: 1,
    });
  }
  else {
    const tagScene = {
      elms: [
        '.tag',
      ],
      delay: 500,
      offset: 1,
    };

    buildScenes(tagScene);
  }
}

// ---------------------------------------------------------- Konami Code - Shhhhh... //
function getMouseCoords(e) {
  const elm = e || window.event;

  const x = elm.pageX;
  const y = elm.pageY;

  const coords = {
    x,
    y,
  };

  return coords;
}

const linePattern = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
let lineCurrent = 0;
let konamiLoaded = false;

const lineKeyHandler = event => {
  if (konamiLoaded) {
    return false;
  }

  // If the key isn't in the pattern, or isn't the current key in the pattern, reset
  if (linePattern.indexOf(event.key) < 0 || event.key !== linePattern[lineCurrent]) {
    lineCurrent = 0;
    return false;
  }

  // Update how much of the pattern is complete
  lineCurrent += 1;

  // If complete //
  if (linePattern.length === lineCurrent) {
    lineCurrent = 0;

    $('body').css({ overflowX: 'hidden' });

    $('body').on('click', () => {
      const coords = getMouseCoords();
      const line = `<hr class="konami ${coords.x}-${coords.y}">`;

      const lineWidth = Math.random() * ((window.innerHeight / 1.5) - 100) + 100;

      $('body').append(line);

      setTimeout(() => {
        $(`hr.${coords.x}-${coords.y}`).css({
          left: coords.x,
          top: coords.y,
          width: `${lineWidth}px`,
        });
      }, 250);
    });

    konamiLoaded = true;
  }

  return false;
};

// Listen for keydown events //
document.addEventListener('keydown', lineKeyHandler, false);

// 404 Page //
const fourZeroFourPattern = ['p', 'r', 'i', 'n', 'c', 'e', 's', 's'];
let fourZeroFourCurrent = 0;
let fourZeroFourLoaded = false;

const fourZeroFourKeyHandler = event => {
  if (fourZeroFourLoaded) {
    return false;
  }

  function getRandomBackground(min, max) {
    const mi = Math.ceil(min);
    const ma = Math.floor(max);
    return Math.floor(Math.random() * (ma - mi + 1)) + mi;
  }

  // If the key isn't in the pattern, or isn't the current key in the pattern, reset
  if (fourZeroFourPattern.indexOf(event.key) < 0 || event.key !== fourZeroFourPattern[fourZeroFourCurrent]) {
    fourZeroFourCurrent = 0;
    return false;
  }

  // Update how much of the pattern is complete
  fourZeroFourCurrent += 1;

  // If complete //
  if (fourZeroFourPattern.length === fourZeroFourCurrent) {
    fourZeroFourCurrent = 0;

    $('body').addClass('fourZeroFour');

    // Nelson: "Ha ha" //
    console.info(
      '%cI know design… I went to a fancy art school!!!',
      'background-color: #f00; color: #fff; display: inline-block; font-family:"american typewriter"; font-size: 50px; border: 3px solid red ; border-radius: 7px ; padding: 10px ; margin: 20px; box-shadow: 2px 2px 1px yellow;'
    );

    const randomBackground = getRandomBackground(1, 4);
    $('.fourZeroFourBkg').addClass(`background-${randomBackground}`);

    if (randomBackground === 1) {
      $('.container-404').addClass('light-text');
    }

    fourZeroFourLoaded = true;
  }

  return false;
};

// Listen for keydown events //
const page404 = document.querySelector('.container-404');

if (page404) {
  document.addEventListener('keydown', fourZeroFourKeyHandler, false);
}
